// MUI components and icons
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Project hooks
import { useAppSelector } from "../../../../../services/StoreHelper";

// External libraries
import { BounceLoader } from "react-spinners";

interface CancelAgreementDialogProps {
  open: boolean;
  onClose: () => void;
  message: string;
  inTerm: string;
  onlineCancelReview: boolean;
}

export default function ProcessingDialog({
  open,
  onClose,
  message,
  inTerm,
  onlineCancelReview,
}: CancelAgreementDialogProps) {
  const { cancel_process, club } = useAppSelector((state) => state.app);

  // Toggle this however you want for now (later you can pull from state, env, etc.)
  const { usesSpanish } = club;

  const t = (en: string, es: string) => (usesSpanish ? es : en);

  const titleText = onlineCancelReview
    ? t(
        "Your cancellation request has been submitted.",
        "Tu solicitud de cancelación ha sido enviada."
      )
    : t(
        "Your cancellation has been scheduled.",
        "Tu cancelación ha sido programada."
      );

  const subtitleText = onlineCancelReview
    ? t(
        "An email will be sent once processed.",
        "Se enviará un correo cuando se procese."
      )
    : t(
        "A confirmation email has been sent.",
        "Se ha enviado un correo de confirmación."
      );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          fontFamily: "'Montserrat', sans-serif",
          borderRadius: 2,
          padding: 3,
          width: 400,
          "& .MuiInputBase-inputMultiline": {
            padding: "12px 12px 12px 12px",
          },
          "&::placeholder": {
            paddingLeft: "4px",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: 24,
          pb: 1,
          fontFamily: "'Montserrat', sans-serif",
          m: 0,
          p: 2,
        }}
      >
        {titleText}
        <IconButton
          aria-label={t("close", "cerrar")}
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ fontFamily: "'Montserrat', sans-serif" }}>
        <div>
          {!cancel_process && (
            <Typography
              variant="body1"
              mb={1}
              sx={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {subtitleText}
            </Typography>
          )}

          {cancel_process && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "inherit",
                width: "100%",
              }}
            >
              <BounceLoader />
              {/* Optional: add visible text under loader */}
              {/* <div style={{ marginTop: 12 }}>{t("Processing...", "Procesando...")}</div> */}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}